import { Flex } from '@zillow/constellation';
import { IconArchived, IconInbox, IconSpam, IconStar } from '../Icons';

type Props = {
  isInbox?: boolean;
  isArchived?: boolean;
  isSpam?: boolean;
  isGray?: boolean;
  isStar?: boolean;
};

const ViewByModuleIcon = ({
  isInbox = false,
  isArchived = false,
  isSpam = false,
  isGray = false,
  isStar = false,
}: Props): JSX.Element => {
  return (
    <Flex display="flex" alignItems="center" marginRight={1}>
      {isInbox && <IconInbox isGray={isGray} />}
      {isArchived && <IconArchived isGray={isGray} />}
      {isSpam && <IconSpam isGray={isGray} />}
      {isStar && <IconStar isGray={isGray} />}
    </Flex>
  );
};

export default ViewByModuleIcon;
